export default __webpack_public_path__ + "static/media/AphidAI.fb7d1a23.png";